import React from "react"

function IconLayoutUserRightPanel({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="layout-user-right-panel"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-layout-user-right-panel"
      {...props}
    >
      <path
        d="M19.636 2.618c.91 0 1.658.697 1.739 1.587l.007.159v15.272c0 .91-.697 1.658-1.587 1.739l-.159.007H4.364c-.91 0-1.658-.697-1.739-1.587l-.007-.159V4.364c0-.91.697-1.658 1.587-1.739l.159-.007h15.272zm-4.09 1.31H4.363c-.211 0-.387.149-.428.348l-.009.088v15.272c0 .211.15.387.349.428l.088.009h.435l.001-3.687c0-.975.647-1.832 1.585-2.098l1.047-.297a3.078 3.078 0 0 1-.902-2.173V9.93c0-1.731 1.443-3.134 3.223-3.134 1.78 0 3.222 1.403 3.222 3.134v1.888c0 .838-.338 1.6-.89 2.161l1.063.306a2.182 2.182 0 0 1 1.58 2.097l-.002 3.69h.82V3.928zM9.941 14.945l-.19.005c-.23 0-.454-.024-.67-.068l-2.339.664a.873.873 0 0 0-.626.724l-.008.115-.001 3.688h7.31v-3.692a.873.873 0 0 0-.511-.795l-.12-.044-2.327-.668c-.168.037-.341.06-.518.07zm9.694-11.019h-2.781v16.146h2.781c.211 0 .387-.15.428-.349l.009-.088V4.364c0-.211-.15-.387-.349-.428l-.088-.009zM9.753 8.105c-1.01 0-1.824.74-1.907 1.669l-.007.156v1.888c0 .73.454 1.368 1.1 1.658l.127.051a1.893 1.893 0 0 0 .49.108l.16.007.152-.003.236-.028.129-.027.078-.02c.739-.215 1.28-.843 1.348-1.588l.007-.158V9.93c0-1-.849-1.825-1.913-1.825z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconLayoutUserRightPanel
